import React, { useEffect, useRef, useState } from "react";
import { ReactComponent as Doc } from "../../../../../../assets/images/fileManager/documentIcon.svg";
import { ReactComponent as Profile } from "../../../../../../assets/images/fileManager/profile.svg";
import { ReactComponent as Info } from "../../../../../../assets/images/icons/info.svg";
import emptyProfile from "../../../../../../assets/images/icons/empty-profile.svg";
import moment from "moment-jalaali";
import ReactTooltip from "react-tooltip";
import { ResourceAccessEnum, UserType } from "../../../../../../interfaces/general";
import { useAppSelector } from "../../../../../../redux/hooks";
import { advancedResponseValidator, get, getAll, responseValidator } from "../../../../../../scripts/api";
import API from "../../../../../../urls/api";
import { getObject } from "../../../fileManager.function";
import { addZeroToStart, allFormatRegex, isFolder, isTouchScreen, setIconFile, UnitConvertStandard } from "../../../../../../scripts/helpers";
import { handleSetInformationModalStatus, handleSetShareModalStatus } from "../../../fileManager.actions";
import Dialog from "../../../../dialog/dialog.index";
import { DialogSize } from "../../../../dialog/dialog.interface";
import PathDisplayIndex from "../../../../displayFaEn/diplayFaEnPath/pathDisplay.index";
import { ENVIRONMENT } from "../../../../../../environment";
import smallTick from "../../../../../../assets/images/svg/small-tick.svg";
import smallClose from "../../../../../../assets/images/svg/small-close.svg";
import smallRefresh from "../../../../../../assets/images/svg/small-refresh.svg";
import { shallowEqual } from "react-redux";

export default function InformationModal(): JSX.Element {
    const { selectedResources, informationModalStatus, shareModalStatus } = useAppSelector(
        ({ fileManager: { selectedResources, informationModalStatus, shareModalStatus } }) => ({
            selectedResources,
            informationModalStatus,
            shareModalStatus
        }),
        shallowEqual
    );
    const { user } = useAppSelector(({ auth: { user } }) => ({ user }), shallowEqual);
    const [sectionName, setSectionName] = useState<string>("Detail");
    const [filePath, setFilePath] = useState<string>("");
    const [fileInfo, setFileInfo] = useState<any>(undefined);
    const [users, setUsers] = useState<UserType[] | undefined>(undefined);
    const [selectedUsers, setSelectedUsers] = useState<UserType[]>([]);
    const interval = useRef<any>();

    useEffect(() => {
        ReactTooltip.rebuild();
    });

    useEffect(() => {
        if (sectionName === "Virus") {
            interval.current = setInterval(() => {
                get((data, status) => {
                    if (advancedResponseValidator(data, status)) {
                        setFileInfo(data);
                    }
                }, API.fileManager.getObject(fileInfo.id));
            }, 30000);
        } else {
            clearInterval(interval.current);
        }
    }, [sectionName]);

    useEffect(() => {
        if (sectionName === "Virus" && fileInfo) {
            get((data, status) => {
                if (advancedResponseValidator(data, status)) {
                    setFileInfo(data);
                }
            }, API.fileManager.getObject(fileInfo.id));
        }
    }, [sectionName]);

    useEffect(() => {
        if (informationModalStatus) {
            setFileInfo(selectedResources[0]);
            getResourceInformation();
        }
    }, [informationModalStatus]);

    useEffect(() => {
        if (informationModalStatus) {
            getAll((data, status) => {
                if (responseValidator(status)) {
                    setUsers(data.result.map((contact: any) => ({ ...contact, phone: addZeroToStart(contact.phone) })));
                }
            }, API.contact.list());
        }
    }, [informationModalStatus]);

    const getObjectData = () => {
        if (informationModalStatus) {
            if (users && selectedResources.length > 0) {
                getObject(selectedResources[0].id).then((data) => {
                    if (data.antivirus_status) {
                        setFileInfo({ ...fileInfo, antivirus_status: data.antivirus_status });
                    }
                    if (data.user_access) {
                        const selected: any = data.user_access
                            .filter((item) => item.user)
                            .map((item) => {
                                const user = users.find((user) => user.contact_id === item.user.id);
                                return {
                                    ...item.user,
                                    phone: addZeroToStart(item.user.phone),
                                    access: item.access,
                                    ...user
                                };
                            });
                        setSelectedUsers([{ ...user }, ...selected]);
                    } else {
                        setSelectedUsers([]);
                    }
                });
            }
        }
    };

    useEffect(() => {
        getObjectData();
    }, [users, shareModalStatus]);

    const getResourceInformation = () => {
        let tempPath = "";
        if (selectedResources[0].parent) {
            get(async (data, status) => {
                tempPath = `${data.folder_metadata.path}${selectedResources[0].name}`;
                setFilePath(tempPath);
            }, API.fileManager.getObject(selectedResources[0].parent));
        } else {
            get(async (data, status) => {
                if (responseValidator(status)) {
                    setFilePath("/" + selectedResources[0].name);
                }
            }, API.fileManager.getObject(selectedResources[0].id));
        }
    };

    const backgroundImages: React.CSSProperties = fileInfo
        ? {
              backgroundImage: `url('${fileInfo.download_url}?thumb=true')`,
              backgroundSize: "contain"
          }
        : {};

    const FileFeature = ["نوع فایل", "حجم فایل", "مالک", "تاریخ آخرین تغییر", "تاریخ ایجاد", "آخرین بازدید", "مکان فایل"];

    return (
        <Dialog
            status={informationModalStatus}
            size={DialogSize.FULL}
            onClose={() => {
                handleSetInformationModalStatus(false);
                setSectionName("Detail");
                clearInterval(interval.current);
            }}
            title={fileInfo && fileInfo.name}
            icon={fileInfo && setIconFile(fileInfo.name, isFolder(fileInfo))}
        >
            <div className={`${window.screen.width >= 768 ? "mt-[80px]" : ""} border-b-2 md:px-0`}>
                <div className="flex justify-between items-center w-full md:w-[50%]">
                    <button
                        className={`border-b-2 md:ml-18 py-2 text-center w-full font-medium text-sm ${sectionName === "Detail" ? "text-primary-600 border-b-[#2991FF]" : "border-b-white text-secondary-600"}`}
                        onClick={() => setSectionName("Detail")}
                    >
                        {"جزئیات"}
                    </button>

                    {fileInfo && fileInfo.antivirus_status && (fileInfo.malware_risk === null || fileInfo.malware_risk >= 0) && (
                        <button
                            className={`border-b-2 md:ml-18 py-2 text-center w-full font-medium text-sm ${sectionName === "Virus" ? "text-primary-600 border-b-[#2991FF]" : "border-b-white text-secondary-600"}`}
                            onClick={() => setSectionName("Virus")}
                        >
                            آنتی‌ویروس
                        </button>
                    )}
                </div>
            </div>
            {sectionName === "Detail" ? (
                <div>
                    <div className={`${fileInfo && !fileInfo.has_cover && "hidden"} border-b-2 py-6 flex justify-center`}>
                        {fileInfo ? (
                            <div className="max-w-none min-w-[150px] w-[30vw] aspect-video rounded-[8px] bg-no-repeat" style={backgroundImages} />
                        ) : (
                            <></>
                        )}
                    </div>
                    <div className={`md:flex ${selectedUsers.length === 0 ? "" : "justify-center"} w-full p-4`}>
                        <div className={`w-full md:w-[50%] pb-4 ${selectedUsers.length === 0 ? "hidden" : ""}`}>
                            <div className="flex items-center font-bold text-base py-2">
                                <div className="pl-4">
                                    <Profile />
                                </div>
                                <div className="text-base font-bold text-secondary-800">{"دسترسی افراد"}</div>
                            </div>
                            <div className="text-sm font-medium md:h-auto md:max-h-[70vh] !overflow-x-auto no-scrollbar">
                                {
                                    <table className="table-auto h-full w-[80%]">
                                        <tbody>
                                            <tr className={`${isTouchScreen() && "hidden"}`}>
                                                <td className="py-2 flex items-center">
                                                    <div className="pr-2 w-[100px] truncate">{"نام"}</div>
                                                </td>
                                                <td className="text-secondary-600 py-2 -translate-x-7">{`شماره در ${ENVIRONMENT.brandName}`}</td>
                                                <td className="text-secondary-500 pr-[75px] py-2">
                                                    <div className="flex ">
                                                        <span>{"دسترسی"}</span>
                                                        {window.screen.width < 765 && <ReactTooltip place="right" effect="float" />}
                                                        <span
                                                            data-event={window.screen.width < 765 ? "click" : ""}
                                                            data-multiline={true}
                                                            data-tip={
                                                                "افرادی که دسترسی خواندن دارند امکان دانلود و<br/> مشاهده فایل را خواهند داشت و <br/>افرادی که دسترسی نوشتن دارند می‌توانند آن را ویرایش کنند."
                                                            }
                                                        >
                                                            <Info />
                                                        </span>
                                                    </div>
                                                </td>
                                            </tr>
                                            {selectedUsers.length > 0 &&
                                                selectedUsers.map((itemList) => {
                                                    return (
                                                        <tr key={itemList.phone} className="group">
                                                            <td
                                                                className={`py-2 flex items-center ${isTouchScreen() ? "pr-2" : "pr-6 group-even:!bg-[#F3F7FE]"} py-2 pr-2 flex items-center first:rounded-r-[10px] last:rounded-l-[10px]`}
                                                            >
                                                                <img
                                                                    className="block w-[48px] h-[48px] rounded-full object-fit"
                                                                    src={itemList.picture_url ? itemList.picture_url : emptyProfile}
                                                                    alt={itemList.name}
                                                                />
                                                                <div className="pr-2 w-[150px] truncate">{itemList.name}</div>
                                                            </td>
                                                            <td
                                                                className={`${isTouchScreen() ? "text-secondary-500" : "group-even:!bg-[#F3F7FE] text-secondary-600"} pr-8 py-2 first:rounded-r-[10px] last:rounded-l-[10px]`}
                                                            >
                                                                {isTouchScreen()
                                                                    ? itemList.access === ResourceAccessEnum.READ
                                                                        ? "خواندن"
                                                                        : "نوشتن"
                                                                    : itemList.phone}
                                                            </td>
                                                            <td
                                                                className={`text-secondary-600 ${!isTouchScreen() && "group-even:!bg-[#F3F7FE]"} pr-[75px] pl- py-2 first:rounded-r-[10px] last:rounded-l-[10px]`}
                                                            >
                                                                {isTouchScreen()
                                                                    ? itemList.phone
                                                                    : itemList.access === ResourceAccessEnum.READ
                                                                      ? "خواندن"
                                                                      : "نوشتن"}
                                                            </td>
                                                        </tr>
                                                    );
                                                })}
                                        </tbody>
                                    </table>
                                }
                                <button
                                    onClick={() => handleSetShareModalStatus(true)}
                                    className="w-full text-primary-600 py-3 mt-8 border-[1.5px] border-primary-600 rounded-lg lg:w-[80%]"
                                >
                                    اشتراک‌گذاری فایل
                                </button>
                            </div>
                        </div>
                        <div className={`w-full md:px-8 ${selectedUsers.length === 0 ? "" : "w-full md:w-[50%]"}`}>
                            <div className="flex items-center font-bold text-base py-2 md:mb-0 mb-2">
                                <div className="pl-4">
                                    <Doc />
                                </div>
                                <div className="text-secondary-800">{"مشخصات فایل"}</div>
                            </div>
                            {fileInfo && (
                                <div className="w-full md:flex static items-center font-normal text-sm md:py-2 md:max-h-[50vh] !overflow-x-auto no-scrollbar">
                                    <table className="table-auto">
                                        <tbody className="w-full">
                                            <tr>
                                                <td className="py-3">{FileFeature[0]}</td>
                                                <td className="text-secondary-600 py-3 capitalize pr-[120px]">
                                                    {isFolder(fileInfo)
                                                        ? "فولدر"
                                                        : fileInfo.name.match(allFormatRegex)
                                                          ? fileInfo.name.match(allFormatRegex)[0].slice(1)
                                                          : ""}
                                                </td>
                                            </tr>
                                            <tr className={`${isFolder(fileInfo) && "hidden"}`}>
                                                <td className="py-3">{FileFeature[1]}</td>
                                                <td className="text-secondary-600 py-3 pr-[120px]">
                                                    {(Math.round(UnitConvertStandard(fileInfo.size).value * 10) / 10).toFixed(1) +
                                                        `${UnitConvertStandard(fileInfo.size).unit}`}
                                                </td>
                                            </tr>
                                            {/*<tr>*/}
                                            {/*    <td className="py-3">{FileFeature[2]}</td>*/}
                                            {/*    <td className="text-secondary-600 py-3 pr-[120px]">{"خودم"}</td>*/}
                                            {/*</tr>*/}
                                            <tr>
                                                <td className="py-3">{FileFeature[3]}</td>
                                                <td className="flex gap-5 text-secondary-600 py-3 pr-[120px]">
                                                    <span>
                                                        {fileInfo.last_modified
                                                            ? moment.unix(fileInfo.last_modified).format("jYYYY/jMM/jDD")
                                                            : moment.unix(fileInfo.created_at).format("jYYYY/jMM/jDD")}
                                                    </span>
                                                    <span>
                                                        {fileInfo.last_modified
                                                            ? moment.unix(fileInfo.last_modified).format("HH:mm:ss")
                                                            : moment.unix(fileInfo.created_at).format("HH:mm:ss")}
                                                    </span>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="py-3">{FileFeature[4]}</td>
                                                <td className="flex gap-5 text-secondary-600 py-3 pr-[120px]">
                                                    <span>{moment.unix(fileInfo.created_at).format("jYYYY/jMM/jDD")}</span>
                                                    <span>{moment.unix(fileInfo.created_at).format("HH:mm:ss")}</span>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="py-3">{FileFeature[5]}</td>
                                                <td className="flex gap-5 text-secondary-600 py-3 pr-[120px]">
                                                    <span>{moment.unix(fileInfo.last_opened).format("jYYYY/jMM/jDD")}</span>
                                                    <span>{moment.unix(fileInfo.last_opened).format("HH:mm:ss")}</span>
                                                </td>
                                            </tr>
                                            <tr className="md:overflow-x-none overflow-x-auto items-center">
                                                <td className="py-3">{FileFeature[6]}</td>
                                                <td className="text-secondary-600 py-3 pr-[120px]">
                                                    <div
                                                        dir="rtl"
                                                        className="overflow-x-scroll break-words justify-start whitespace-nowrap sm:overflow-hidden sm:whitespace-normal text-right max-w-[35vw] sm:h-auto h-[40px] sm:no-scrollbar"
                                                    >
                                                        <div className="text-justify" dir="rtl">
                                                            <PathDisplayIndex TextInput={"فایل‌های من" + filePath} />
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            ) : (
                <></>
            )}

            {sectionName === "Virus" && (
                <div className="p-4">
                    <h3 className="text-secondary-600 text-[16px] mb-4">نتایج بررسی آنتی‌ویروس</h3>
                    <hr />
                    <div className="flex items-center gap-4 justify-between text-[14px] text-secondary-500 p-4">
                        <p>آنتی‌ویروس</p>
                        <p>وضعیت</p>
                    </div>
                    {fileInfo && fileInfo.antivirus_status
                        ? Object.keys(fileInfo.antivirus_status).map((key) => (
                              <div className="px-4 rounded-[8px] even:bg-secondary-100 h-[40px] flex items-center gap-4 justify-between">
                                  <p className="text-[14px] font-bold text-secondary-800">{key}</p>
                                  <div>
                                      {fileInfo.antivirus_status[key] === null ? (
                                          <div className="text-secondary-400 text-[14px] font-bold flex items-center gap-2">
                                              <p>در حال بررسی</p>
                                              <img src={smallRefresh} alt="refresh" className="animate-spin" />
                                          </div>
                                      ) : fileInfo.antivirus_status[key] ? (
                                          <div className="text-lime-600 text-[14px] font-bold flex items-center gap-2">
                                              <p>سالم</p>
                                              <img src={smallTick} alt="refresh" />
                                          </div>
                                      ) : (
                                          <div className="text-red-600 text-[14px] font-bold flex items-center gap-2">
                                              <p>ناسالم</p>
                                              <img src={smallClose} alt="refresh" />
                                          </div>
                                      )}
                                  </div>
                              </div>
                          ))
                        : "nothing"}
                </div>
            )}
        </Dialog>
    );
}
